var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavoriteRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 14C7.84436 14 7.68603 13.9717 7.52492 13.9151C7.36381 13.8586 7.22214 13.768 7.09992 13.6436L5.94992 12.5743C4.77214 11.4767 3.70825 10.3876 2.75825 9.30693C1.80825 8.22631 1.33325 7.03536 1.33325 5.73409C1.33325 4.67044 1.68325 3.78218 2.38325 3.06931C3.08325 2.35644 3.95547 2 4.99992 2C5.58881 2 6.14436 2.1273 6.66659 2.3819C7.18881 2.63649 7.63325 2.98444 7.99992 3.42574C8.36659 2.98444 8.81103 2.63649 9.33325 2.3819C9.85547 2.1273 10.411 2 10.9999 2C12.0444 2 12.9166 2.35644 13.6166 3.06931C14.3166 3.78218 14.6666 4.67044 14.6666 5.73409C14.6666 7.03536 14.1944 8.22914 13.2499 9.31542C12.3055 10.4017 11.2333 11.4936 10.0333 12.5912L8.89992 13.6436C8.7777 13.768 8.63603 13.8586 8.47492 13.9151C8.31381 13.9717 8.15547 14 7.99992 14Z",
    fill: "#F1001E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteRed);
export default __webpack_public_path__ + "static/media/favorite-red.67f4a2c6fb519abb9120d7019bb3ab08.svg";
export { ForwardRef as ReactComponent };